"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var getPosition = function getPosition(event, validate) {
  var _event$target, _event$target2;

  var value = (event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) || '';
  var formatted = value.substr(0, event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.selectionStart).trim();

  if (validate instanceof RegExp) {
    formatted = (0, _toConsumableArray2["default"])(formatted).filter(function (_char) {
      return validate.test(_char);
    }).join('');
  } else if (typeof validate === 'function') {
    formatted = validate(formatted);
  }

  return formatted.length;
};

var setPosition = function setPosition(cleanPosition, formattedValue, validate, element) {
  if (!isNaN(cleanPosition) && element && formattedValue) {
    var position = 0,
        digitCount = 0;

    if (typeof formattedValue !== 'string') {
      formattedValue = String(formattedValue);
    }

    (0, _toConsumableArray2["default"])(formattedValue).forEach(function (_char2) {
      if (cleanPosition > digitCount) {
        position += 1;
      }

      if (validate instanceof RegExp) {
        if (validate.test(_char2)) {
          digitCount += 1;
        }
      } else if (typeof validate === 'function') {
        if (validate(_char2)) {
          digitCount += 1;
        }
      } else {
        digitCount += 1;
      }
    });
    element === null || element === void 0 ? void 0 : element.setSelectionRange(position, position);
  }
};

var _default = function _default(ref, validate) {
  var cursorPosition = null;
  return [function (event) {
    cursorPosition = getPosition(event, validate);
  }, function (formattedValue) {
    if (!isNaN(cursorPosition)) {
      setPosition(cursorPosition, formattedValue, validate, ref.current);
      cursorPosition = null;
    }
  }];
};

exports["default"] = _default;